import { render } from "./HeaderMainLayout.vue?vue&type=template&id=012c61a6&scoped=true"
import script from "./HeaderMainLayout.vue?vue&type=script&lang=js"
export * from "./HeaderMainLayout.vue?vue&type=script&lang=js"

import "./HeaderMainLayout.vue?vue&type=style&index=0&id=012c61a6&lang=css"
import "./HeaderMainLayout.vue?vue&type=style&index=1&id=012c61a6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\anton\\OneDrive\\Escritorios\\09-07-2023\\mailsender\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012c61a6"]])

export default __exports__